import SuccessView                     from 'scripts/defa/basic/view-success-view';
import SubscriptionTerminateChoiceForm from 'scripts/defa/subscriptions/view-subscription-terminate-choice-form';
import SubscriptionTerminateVerificationForm
									   from 'scripts/defa/subscriptions/view-subscription-terminate-verification-form';
import Flow                            from 'scripts/poppet/flow';
import template                        from 'templates/subscriptionTerminateFlow.jst.html';

/**
 * defa.views.SubscriptionTerminateFlow
 * A view-flow to terminate a Subscription.
 * @version 1.2.0
 */

const channelUser = Bb.Radio.channel( 'user' );

const selectors = {
	container: '[data-region=terminate-container]',
};

const SubscriptionTerminateFlow = Flow.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	regions: {
		container: selectors.container,
	},
	
	modelEvents: {
		'sync' : 'onModelSync',
	},
	
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the model syncs
	 * @void
	 */
	onModelSync: function() {
		let user = null;
		switch( this.selectedEnding ) {
			
			case 'deactivate' :
				this.animateChildOut();
				break;
				
			case 'terminate' :
				user = channelUser.request( 'model' );
				user.set( 'transientUnits', _.without( user.get( 'transientUnits' ), this.model.get( 'unit' ) ) );
		
				this._showTerminateSuccess();
				break;
		}
	},
	
	/**
	 * Triggers when an ending is selected.
	 * @void
	 */
	onChildviewEndingSelected: function ( ending ) {
		this.selectedEnding = ending;
		this.dispatch();
	},
	
	/**
	 * Triggers when a child view asks to execute the terminate.
	 * @void
	 */
	onChildviewTerminate: function () {
		
		switch ( this.selectedEnding ) {
			
			case 'deactivate' :
				//this.listenToOnce( this.model, 'sync', this.animateChildOut );
				this.model.disable();
				break;
			
			case 'terminate' :
				//this.listenTo( this.model, 'sync', this.onSubscriptionDestroySync );
				this.model.destroy();
				break;
			
		}
	},
	
	/**
	 * Triggers when a successView asks to close up.
	 * @void
	 */
	onChildviewSuccessClose: function ( childView ) {
		childView.animateOut();
	},
	
	/**
	 * Triggers when the subscription is confirmed destroyed from server.
	 * @void
	 */
	/*onSubscriptionDestroySync: function ( model ) {
		
		let user = channelUser.request( 'model' );
		user.set( 'transientUnits', _.without( user.get( 'transientUnits' ), model.get( 'unit' ) ) );
		
		this._showTerminateSuccess();
	},*/
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Dispatches the correct view based upon this layouts logic without updating the url.
	 * @void
	 */
	dispatch: function () {
		
		// if no option is made
		if ( !this.selectedEnding ) {
			this._showTerminateChoices();
		}
		
		// if the option is made
		if ( this.selectedEnding ) {
			this._showTerminateVerification();
		}
		
	},
	
	/**
	 * Shows the options for subscription termination.
	 * @void
	 */
	_showTerminateChoices: function () {
		
		let subscriptionTerminateChoiceForm = new SubscriptionTerminateChoiceForm( _.extend( this.options, {
			model: this.model,
		} ) );
		
		this.showChildView( 'container', subscriptionTerminateChoiceForm );
	},
	
	/**
	 * Shows the last verification before subscription ends.
	 * @void
	 */
	_showTerminateVerification: function () {
		
		let subscriptionTerminateVerificationForm = new SubscriptionTerminateVerificationForm( _.extend( this.options, {
			model : this.model,
			ending: this.selectedEnding,
		} ) );
		
		this.showChildView( 'container', subscriptionTerminateVerificationForm );
	},
	
	/**
	 * Triggers when the server acnowledges the model's destruction.
	 * @void
	 */
	_showTerminateSuccess: function () {
		
		// remove the unit from the current user list of units
		
		let successView = new SuccessView( {
			context  : 'subscription:terminated',
			closeLink: {
				event: 'unit:list',
			},
		} );
		
		this.showChildView( 'container', successView );
	},
	
} );


export default SubscriptionTerminateFlow;